import React from 'react';

const Categories = (props) => {
  return <div>Categories Page</div>;
};

export default Categories;
